export default __webpack_public_path__ + "static/media/copy.e3ece292.svg";